import { TablePaginationContextState } from 'modules/experiments/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export const initialTablePaginationContextState: TablePaginationContextState = {
  page: 1,
  setPage: noop,
  resetPage: noop,
  pageSize: 10,
  setPageSize: noop,
};

export const TablePaginationContext = createContext(initialTablePaginationContextState);

export const useTablePaginationContext = () => useContext(TablePaginationContext);
